import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { ROLE } from '@/lib/roles'
import { TaskPlugins } from '@/features/task-plugins'

export const Route = createFileRoute('/_authenticated/task-plugins/')({
  beforeLoad: () => {
    if ((useAuthStore.getState().auth.user?.role ?? 0) < ROLE.SUPER_ADMIN)
      throw redirect({ to: '/403' })
  },
  component: TaskPlugins,
})
